const DAY_MS = 24 * 60 * 60 * 1000

/**
 * Calendar months in UTC, clamped to the month's last day: Jan 31 + 1 month = Feb 28/29.
 * Time of day is kept, so a period bought at 14:21 ends at 14:21.
 */
export function addMonthsUtc(date: Date, months: number): Date {
  const result = new Date(date.getTime())
  const day = result.getUTCDate()
  result.setUTCDate(1)
  result.setUTCMonth(result.getUTCMonth() + months)
  const lastDay = new Date(
    Date.UTC(result.getUTCFullYear(), result.getUTCMonth() + 1, 0),
  ).getUTCDate()
  result.setUTCDate(Math.min(day, lastDay))
  return result
}

export function addDays(date: Date, days: number): Date {
  return new Date(date.getTime() + days * DAY_MS)
}

/** "18 дней тарифа": whole days left, rounded up, so the last hours still read as "1". */
export function daysLeft(endsAt: Date, now: Date): number {
  return Math.max(0, Math.ceil((endsAt.getTime() - now.getTime()) / DAY_MS))
}
